import { Link } from "react-router-dom";

const BuyOneGetOneOffer = () => {
  return (
    <section className="pt-16 px-4 bg-sec pb-20">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">

          {/* LEFT – BOGO Banner */}
          <div className="relative bbg-white rounded-3xl overflow-hidden  flex items-center justify-center p-10">
            
            {/* Offer Text */}
            <div className="text-center space-y-6">
              <p className="text-sm tracking-widest text-gray-500">
                LIMITED TIME OFFER
              </p>

              <h2 className="text-5xl font-extrabold text-gray-900 leading-tight">
                BUY 1 <br /> GET 1 FREE
              </h2>

              <p className="text-gray-600 text-lg pb-5">
                Double the glow. No extra cost.
              </p>
{/* 
              <button className="bg-black text-white px-8 py-3 text-sm font-semibold tracking-wide hover:bg-gray-800 transition">
                SHOP THE OFFER
              </button> */}
              <div>
                 <Link to={"/product-category/shampoo"} className=" text-white bg-accent hover:bg-secondary px-8 py-2 text-sm font-semibold tracking-wide transition ">
                SHOP THE OFFER
              </Link>
              </div>
             
            </div>
          </div>

          {/* RIGHT – Products Visual */}
          <div className="relative bg-gradient-to-br  from-[gray-100] to-gray-200 rounded-3xl overflow-hidden h-[420px] flex items-center justify-center">
            
            {/* First Product */}
            <img
              src="https://i.ibb.co/QmcrgNW/Clariss-Shampoo-Biotin-copy.png"
              alt="Product 1"
              className="bbg-gray-200 border border-gray-300 w-52 h-52 object-cover rounded-2xl shadow-2xl absolute left-10 top-20 rrotate-[-8deg]"
            />

            {/* PLUS Icon */}
            <div className="text-5xl font-bold text-gray-700">+</div>

            {/* Second Product */}
            <img
              src="https://i.ibb.co/qDdFw4Y/Clariss-Shampoo-Keratin-copy.png"
              alt="Product 2"
              className="bbg-gray-200 border border-gray-300 w-52 h-52 object-cover rounded-2xl shadow-2xl absolute right-10 top-20 rrotate-[8deg]"
            />

            {/* FREE Badge */}
            <div className="absolute bottom-6 bg-secondary text-white px-6 py-2 text-sm tracking-wide rounded-full">
              Second One FREE
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BuyOneGetOneOffer;
